import ApplicationController from './application_controller'

export default class UnselectRadioOnClickController extends ApplicationController {
  static targets = ['label']

  connect () {
    this.hiddenField = document.querySelector('input[name="order[quotation_attributes][forced_transport_type]"]');
    this.labelTargets.forEach((label) => {
      if (!label.hasClickEvent) {
        label.addEventListener("click", this.handleClick.bind(this))
        label.hasClickEvent = true;
      }
    });
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const radio = event.currentTarget.querySelector('input[type="radio"]');
    if (radio) {
      const wasChecked = radio.checked;
      radio.checked = !wasChecked;
      radio.dispatchEvent(new Event("change", { bubbles: true }));

      if (!wasChecked) {
        this.hiddenField.value = radio.value;
      } else {
        this.hiddenField.value = ""; // Unselecting the radio
      }
    }
  }
}
